export default __webpack_public_path__ + "339fbf990c12bd66117e9d76190ae6d5.png";